module.exports = __webpack_public_path__ + "static/media/plus_rounded_wine.9469f8d0.svg";